import { combineReducers } from 'redux'

import alertNotesReport from 'src/store/modules/reports/alertNotesReport'
import carePlanReport from 'src/store/modules/reports/carePlanReport'
import caregiversShiftReport from 'src/store/modules/reports/caregiversShiftReport'
import caseManagerCensus from 'src/store/modules/reports/caseManagerCensus'
import enrollmentReport from 'src/store/modules/reports/enrollmentReport'
import patientEvents from 'src/store/modules/reports/patientEvents'
import patientPoints from 'src/store/modules/reports/patientPoints'
import programReport from 'src/store/modules/reports/programReport'
import urgentCareReport from 'src/store/modules/reports/urgentCareReport'

export default combineReducers({
  alertNotesReport,
  carePlanReport,
  caregiversShiftReport,
  caseManagerCensus,
  enrollmentReport,
  patientEvents,
  patientPoints,
  programReport,
  urgentCareReport
})

export * from 'src/store/modules/reports/caseManagerCensus'
export * from 'src/store/modules/reports/carePlanReport'
export * from 'src/store/modules/reports/patientPoints'
export * from 'src/store/modules/reports/enrollmentReport'
export * from 'src/store/modules/reports/patientEvents'
export * from 'src/store/modules/reports/urgentCareReport'
export * from 'src/store/modules/reports/alertNotesReport'
export * from 'src/store/modules/reports/caregiversShiftReport'
export * from 'src/store/modules/reports/programReport'
export * from 'src/store/modules/reports/chartReviewReport'
